import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Theme {
    selectedTheme: string
}

const initialState: Theme = {
    selectedTheme: 'theme3'
}

const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setSelectedTheme(state,action: PayloadAction<{ selectedTheme }>){
            state.selectedTheme = action.payload.selectedTheme
        }
    }
})

export const {
    setSelectedTheme
} = themeSlice.actions;

export default themeSlice.reducer;